module.exports = __webpack_public_path__ + "static/shoes-ultra-light-weight-c61d6a7eeebdf8b359bea05e9286930e.png";